mutation EntityTagTravelerCreate($input: EntityTagTravelerCreateInput!) {
  entityTagTravelerCreate(input: $input) {
    entityTags {
      id
      tagId
      entityId
      appId
    }
  }
}
